import { render, staticRenderFns } from "./PedidosTabelaItemsPo.vue?vue&type=template&id=bcdc5216&"
import script from "./PedidosTabelaItemsPo.vue?vue&type=script&lang=ts&"
export * from "./PedidosTabelaItemsPo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VSimpleTable,VTooltip})
